import { useState } from 'react';
import { useShell } from '../../shell-context.js';
import { errorCode } from '../personnel/source.js';
import { purchaseOrderPath } from './orders.js';
import { RfqDetailView } from './RfqDetailView.js';
import { RfqList } from './RfqList.js';
import { requisitionPath } from './requisitions.js';
import { RFQ_PATH, type RfqRoute, rfqPath } from './rfqs.js';
import type { PurchaseOrderEditor, RfqSource } from './source.js';

export interface RfqScreenProps {
  source: RfqSource;
  /** Sorgu dizesinden (`?id=…`, `?id=…&tab=comparison`; `rfqRoute`). */
  route: RfqRoute;
  /** Ofisin bugünü (`YYYY-MM-DD`); verilmezse tarayıcının UTC günü. */
  today?: string;
  /** Kartta gösterilecek bildirim (ör. "RFQ açıldı"). */
  message?: string | null;
  /** Seçilmiş RFQ'dan sipariş (ADR 0040 #179); verilmezse "Create PO" yok. */
  orders?: PurchaseOrderEditor;
}

/**
 * RFQ (M12b Task 14; `satin-alma-akisi.jpeg` "Supplier Comparison"): liste ve RFQ kartı
 * (karşılaştırma ve seçim). Yalnız ofiste; gemide bilgi sayfası açılır (ADR 0026 §1).
 */
export function RfqScreen({ source, route, today, message = null, orders }: RfqScreenProps) {
  const shell = useShell();
  const [notice, setNotice] = useState<string | null>(message);
  const go = (next: RfqRoute) => {
    setNotice(null);
    shell?.navigate(rfqPath(next));
  };
  if (route.view === 'detail') {
    return (
      <RfqDetailView
        key={route.id}
        source={source}
        id={route.id}
        tab={route.tab}
        today={today ?? new Date().toISOString().slice(0, 10)}
        message={notice}
        onTab={(tab) => shell?.navigate(rfqPath({ view: 'detail', id: route.id, tab }))}
        onBack={() => go({ view: 'list' })}
        onOpenRequisition={(id) => shell?.navigate(requisitionPath({ view: 'detail', id }))}
        onOpenOrder={(id) =>
          shell?.navigate(purchaseOrderPath({ view: 'detail', id, tab: 'items' }))
        }
        {...(orders
          ? {
              onCreateOrder: async (rfq) => {
                try {
                  const order = await orders.create(rfq.id);
                  shell?.navigate(
                    purchaseOrderPath({ view: 'detail', id: order.id, tab: 'items' }),
                  );
                  return null;
                } catch (error) {
                  return errorCode(error);
                }
              },
            }
          : {})}
      />
    );
  }
  return <RfqList source={source} onOpen={(id) => go({ view: 'detail', id, tab: 'details' })} />;
}

export { RFQ_PATH };
